import type * as TYPES from './type'
import API from '@/services/http'
import type { FeePayload, FeeState } from '@/store/serviceProviderSlice/types'

/**
 * 运费试算
 * @param payload
 * @returns
 */
export const getFeeList = async (payload: FeePayload) => {
  const res = await API.toast.takeLatest<FeeState>('getFeeList', 'post', '/api/fee/trial/calculate', payload)
  try {
    res.data?.shippingFeeResults?.forEach((item) => {
      item?.shippingResults?.forEach((result) => {
        try {
          result.channelCustomParamParse = JSON.parse(result.channelCustomParam)
        } catch (error) {}
      })
    })
  } catch (error) {}
  return res
}

/** 新增商家运费配置 */
export const feeSettingAdd = (payload: TYPES.OneshipFreightSettingVO) => {
  return API.toast.post('/api/fee/setting/add', {
    data: payload,
  })
}

/** 删除商家运费配置 */
export const feeSettingDelete = (settingSeq: string) => {
  return API.toast.post('/api/fee/setting/delete', { settingSeq })
}

/** 更新商家运费配置 */
export const feeSettingUpdate = (payload: TYPES.OneshipFreightSettingVO) => {
  return API.toast.post('/api/fee/setting/update', {
    data: payload,
  })
}

/** 分页查询商家运费配置 */
export const feeSettingList = () => {
  return API.toast.post<TYPES.SettingPageRes>('/api/fee/setting/page', {
    pageNum: 1,
    pageSize: 999,
  })
}

/** 商家自定义配置，服务产品列表 */
export const feeSettingExpressList = () => {
  return API.toast.post<TYPES.FreightSettingExpressRes>('/api/fee/setting/express/list')
}

/**
 * **接口** [计算商家自定义运费↗](http://api-doc-sl.inshopline.com/#/project/74/feature%2F20230223_1784_seller_freight/interface/0ed6428022478d76f05ce5ec0ddcd54b)
 * @请求头 `POST /api/fee/setting/calculate`
 * @更新时间 `2023-02-07 20:33:34`
 */
export function calculateCustomFreightMultiple(data?: TYPES.OneshipSellerFreightRequest) {
  return API.toast.post<TYPES.CalculateRes>('/api/fee/setting/calculate', data)
}

export function calculateCustomFreightSingle(data?: TYPES.OneshipSellerFreightRequest['freightParams'][0]) {
  return API.toast
    .post<TYPES.CalculateRes>('/api/fee/setting/calculate', {
      withoutExceptionAborted: true,
      freightParams: [{ ...data, bizId: 0 }],
    })
    .then((res) => {
      return {
        ...res.data.accepted[0],
        ...{
          errorCode: res.data.rejected?.[0]?.code,
          errorMsg: res.data.rejected?.[0]?.msg,
        },
      }
    })
}
